import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-sidebar-card", "data-theme", "data-collapsable"]

import SectionHeading from '@src/components/patterns/SectionHeading.vue';

interface Props {
	theme?: string;
	isSidebarCard?: boolean;
	isFlow?: boolean;
	isCollapsable?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentCard',
  props: {
    theme: {},
    isSidebarCard: { type: Boolean },
    isFlow: { type: Boolean, default: true },
    isCollapsable: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content-card", { 'flow' : __props.isFlow }]),
    "data-sidebar-card": __props.isSidebarCard ? true : null,
    "data-theme": __props.theme,
    "data-collapsable": __props.isCollapsable ? true : null
  }, [
    (_ctx.$slots.heading)
      ? (_openBlock(), _createBlock(SectionHeading, { key: 0 }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "heading")
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "content")
  ], 10, _hoisted_1))
}
}

})